import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography,
} from '@mui/material';
import {
  GameListEntry,
  GameState,
  GAME_LIST_PLATFORMS,
  GAME_STATES,
  STATE_LABELS,
} from '../types';

interface EditGameListModalProps {
  show: boolean;
  onHide: () => void;
  game: GameListEntry | null;
  onSave: (platform: string, state: GameState) => void;
}

const EditGameListModal = ({
  show,
  onHide,
  game,
  onSave,
}: EditGameListModalProps) => {
  const [platform, setPlatform] = useState('PS5');
  const [state, setState] = useState<GameState>('inProgress');

  useEffect(() => {
    if (show && game) {
      setPlatform(game.platform);
      setState(game.state);
    }
  }, [show, game]);

  return (
    <Dialog open={show} onClose={onHide} maxWidth="xs" fullWidth>
      <DialogTitle>Edit {game?.title}</DialogTitle>

      <DialogContent dividers>
        <FormControl fullWidth sx={{ mb: 2, mt: 1 }}>
          <InputLabel>Platform</InputLabel>
          <Select
            value={platform}
            label="Platform"
            onChange={(e) => setPlatform(e.target.value)}
          >
            {GAME_LIST_PLATFORMS.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth>
          <InputLabel>State</InputLabel>
          <Select
            value={state}
            label="State"
            onChange={(e) => setState(e.target.value as GameState)}
          >
            {GAME_STATES.map((option) => (
              <MenuItem key={option} value={option}>
                {STATE_LABELS[option]}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {state === 'finished' && !game?.dateFinished && (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: 'block', mt: 2 }}
          >
            No completion date recorded. Use &quot;Mark as Completed&quot; on an
            in-progress game to stamp today&apos;s date.
          </Typography>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onHide}>Cancel</Button>
        <Button variant="contained" onClick={() => onSave(platform, state)}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditGameListModal;
